import { useMemo } from 'react';

import type { DomainQueryOptions } from '@/domain/shared/types';
import { useCageDepthSeriesController_getCageDepthSeries } from '@/services/hooks';
import type { DepthSeriesResponseDto } from '@/services/types';

import { mapDepthSeriesToDomain } from './mappers';
import type { DepthSeries, DepthSeriesParams, UseGetDepthSeriesResult } from './types';

const EMPTY: DepthSeries = { cages: [] };

export function useGetCageDepthSeries(
    cageId: number,
    params: DepthSeriesParams,
    options?: DomainQueryOptions<DepthSeriesResponseDto>
): UseGetDepthSeriesResult {
    const query = useCageDepthSeriesController_getCageDepthSeries(cageId, params, options);
    const data = useMemo(() => mapDepthSeriesToDomain(query.data?.data), [query.data?.data]);

    return {
        ...query,
        isLoading: query.isPending,
        data: query.data?.data ? data : EMPTY,
    };
}
